export const ATTENDANCE_FEATURE_OPTIONS = [
  { value: "web_portal_attendance", label: "Web Punch", helper: "Use the browser punch flow." },
  { value: "kiosk_qr_attendance", label: "Kiosk QR", helper: "Scan the live kiosk QR code." },
  { value: "employee_qr_scan", label: "Employee QR", helper: "Use the employee QR scanning flow." },
  { value: "photo_scanner_attendance", label: "Photo Scanner", helper: "Attendance is captured by the Scanner Admin station." },
];


export const getAttendanceFeatureLabel = (value) => {
  const match = ATTENDANCE_FEATURE_OPTIONS.find((option) => option.value === value);
  return match?.label || "Not assigned";
};


export const getEnabledAttendanceOptions = (featureFlags) => ATTENDANCE_FEATURE_OPTIONS.filter((option) => {
  if (option.value === "web_portal_attendance") return featureFlags?.web_portal_attendance;
  if (option.value === "kiosk_qr_attendance") return featureFlags?.kiosk_qr_attendance;
  if (option.value === "employee_qr_scan") return featureFlags?.employee_qr_scan_attendance;
  return featureFlags?.photo_scanner_attendance;
});


export const isScannerAttendanceFeature = (value) => ["kiosk_qr_attendance", "employee_qr_scan"].includes(value);